import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import client from "@/lib/api";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Masthead from "@/components/Masthead";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ArticleDetail from "@/pages/ArticleDetail";
import Subscriptions from "@/pages/Subscriptions";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import Locandina from "@/pages/Locandina";
import Calendario from "@/pages/Calendario";
import Meccanica from "@/pages/Meccanica";
import LegendTeam from "@/pages/LegendTeam";
import AppDownload from "@/pages/AppDownload";
import ThankSponsors from "@/pages/ThankSponsors";
import SponsorStrip from "@/components/SponsorStrip";
import AdBanner from "@/components/AdBanner";
import LiveButton from "@/components/LiveButton";
import MobileContactBar from "@/components/MobileContactBar";
import CookieConsent from "@/components/CookieConsent";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children, sponsors }) {
  return (
    <>
      <Masthead sponsors={sponsors} />
      <main className="bg-background min-h-screen">{children}</main>
      <div className="max-w-7xl mx-auto px-4 my-10"><AdBanner variant="advertise" shape="leaderboard" /></div>
      <SponsorStrip />
      <Footer />
      <div className="h-14 md:hidden" aria-hidden />
      <LiveButton />
      <MobileContactBar />
    </>
  );
}

function App() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    const t = localStorage.getItem("legend_theme");
    if (t === "dark") document.documentElement.classList.add("dark");
    client.get("/sponsors").then((r) => setSponsors(r.data)).catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LanguageProvider>
          <ScrollTop />
          <Routes>
            <Route path="/" element={<Layout sponsors={sponsors}><Home sponsors={sponsors} /></Layout>} />
            <Route path="/articolo/:slug" element={<Layout sponsors={sponsors}><ArticleDetail /></Layout>} />
            <Route path="/abbonamenti" element={<Layout sponsors={sponsors}><Subscriptions /></Layout>} />
            <Route path="/payment/success" element={<Layout sponsors={sponsors}><PaymentSuccess /></Layout>} />
            <Route path="/privacy" element={<Layout sponsors={sponsors}><Privacy /></Layout>} />
            <Route path="/locandina" element={<Layout sponsors={sponsors}><Locandina /></Layout>} />
            <Route path="/calendario" element={<Layout sponsors={sponsors}><Calendario /></Layout>} />
            <Route path="/meccanica" element={<Layout sponsors={sponsors}><Meccanica /></Layout>} />
            <Route path="/legend-team" element={<Layout sponsors={sponsors}><LegendTeam /></Layout>} />
            <Route path="/app" element={<Layout sponsors={sponsors}><AppDownload /></Layout>} />
            <Route path="/grazie-sponsor" element={<Layout sponsors={sponsors}><ThankSponsors /></Layout>} />
            <Route path="/admin" element={<Layout sponsors={sponsors}><Admin /></Layout>} />
          </Routes>
          <CookieConsent />
          <Toaster position="top-center" richColors />
          </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
